/* ==========================================================================
   KINALU · Comportamiento de las secciones
   Archivo: assets/kinalu.js  (se carga con defer desde layout/theme.liquid)
   Se reinicia en el editor de temas (eventos shopify:section:load).
   ========================================================================== */
(function () {
  'use strict';

  /* ---- Carriles con flechas ---------------------------------------------- */
  function initRails(scope) {
    scope.querySelectorAll('[data-k-rail-root]').forEach(function (root) {
      if (root.dataset.kRailReady) return; root.dataset.kRailReady = '1';
      var track = root.querySelector('[data-k-rail-track]'); if (!track) return;
      root.querySelectorAll('[data-k-rail]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = track.firstElementChild;
          var gap = parseFloat(getComputedStyle(track).columnGap) || 24;
          var step = item ? item.getBoundingClientRect().width + gap : 300;
          track.scrollBy({ left: step * Number(btn.getAttribute('data-k-rail')), behavior: 'smooth' });
        });
      });
    });
  }

  /* ---- Vídeos: autoplay sin sonido al entrar en pantalla ----------------- */
  function initVideos(scope) {
    var cards = scope.querySelectorAll('[data-k-video]');
    if (!cards.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var io = ('IntersectionObserver' in window && !reduce) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var card = e.target, v = card.querySelector('video'); if (!v || card.dataset.user) return;
        if (e.isIntersecting) { var p = v.play(); if (p) p.catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: 0.6 }) : null;
    cards.forEach(function (card) {
      if (card.dataset.kVideoReady) return; card.dataset.kVideoReady = '1';
      var v = card.querySelector('video'), btn = card.querySelector('[data-k-video-toggle]'); if (!v) return;
      v.muted = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls');
      var sync = function () { card.classList.toggle('is-playing', !v.paused); };
      v.addEventListener('play', sync); v.addEventListener('pause', sync);
      if (btn) btn.addEventListener('click', function () { card.dataset.user = '1'; if (v.paused) { v.play(); } else { v.pause(); } });
      if (io) io.observe(card);
    });
  }

  /* ---- Shop the look: carrusel de ambientes + ficha por punto ------------ */
  function initLooks(scope) {
    scope.querySelectorAll('[data-k-stl]').forEach(function (root) {
      if (root.dataset.kStlReady) return; root.dataset.kStlReady = '1';
      var track = root.querySelector('[data-k-stl-track]'); if (!track) return;
      var slides = track.children, frame = root.querySelector('[data-k-stl-frame]'), pop = root.querySelector('[data-k-stl-pop]');
      var count = root.querySelector('[data-k-stl-count]'), title = root.querySelector('[data-k-stl-title]'), hint = root.querySelector('[data-k-stl-hint]');
      var i = 0;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function closePop() {
        if (!pop) return; pop.hidden = true;
        root.querySelectorAll('[data-k-hotspot][aria-expanded="true"]').forEach(function (h) { h.setAttribute('aria-expanded', 'false'); });
      }
      function go(n) {
        if (!slides.length) return;
        i = (n + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-100 * i) + '%)';
        closePop();
        if (count) count.textContent = pad(i + 1) + ' / ' + pad(slides.length);
        if (title) title.textContent = slides[i].getAttribute('data-title') || '';
        Array.prototype.forEach.call(slides, function (sl, k) { if (k === i) sl.removeAttribute('inert'); else sl.setAttribute('inert', ''); });
        if (hint) {
          var c = Number(slides[i].getAttribute('data-count')) || 0;
          hint.textContent = c === 0 ? '' : (c === 1 ? 'Toca el punto para ver la pieza' : 'Toca los puntos para ver las ' + c + ' piezas');
        }
      }
      root.querySelectorAll('[data-k-stl-go]').forEach(function (b) {
        b.addEventListener('click', function () { go(i + Number(b.getAttribute('data-k-stl-go'))); });
      });
      root.querySelectorAll('[data-k-hotspot]').forEach(function (h) {
        h.setAttribute('aria-expanded', 'false');
        h.addEventListener('click', function (e) {
          e.stopPropagation();
          var open = h.getAttribute('aria-expanded') === 'true'; closePop(); if (open || !pop) return;
          var d = JSON.parse(h.getAttribute('data-k-hotspot'));
          h.setAttribute('aria-expanded', 'true');
          pop.querySelector('[data-k-pop-img]').src = d.image || '';
          pop.querySelector('[data-k-pop-img]').alt = d.title || '';
          var name = pop.querySelector('[data-k-pop-name]'); name.textContent = d.title; name.href = d.url;
          pop.querySelector('[data-k-pop-price]').textContent = d.price;
          pop.querySelector('[data-k-pop-link]').href = d.url;
          var form = pop.querySelector('[data-k-pop-form]'), add = pop.querySelector('[data-k-pop-add]');
          form.querySelector('input[name="id"]').value = d.variant;
          if (d.single && d.available) { form.hidden = false; add.disabled = false; add.textContent = 'Añadir al carrito'; }
          else if (!d.available) { form.hidden = false; add.disabled = true; add.textContent = 'Agotado'; }
          else { form.hidden = true; }
          pop.hidden = false;
          if (window.matchMedia('(max-width: 720px)').matches) { pop.style.left = ''; pop.style.top = ''; return; }
          var fr = frame.getBoundingClientRect(), hr = h.getBoundingClientRect();
          var x = hr.left - fr.left + 28, y = hr.top - fr.top - 40;
          if (x + pop.offsetWidth > fr.width - 16) x = hr.left - fr.left - pop.offsetWidth - 12;
          y = Math.max(16, Math.min(y, fr.height - pop.offsetHeight - 16));
          pop.style.left = x + 'px'; pop.style.top = y + 'px';
        });
      });
      var close = root.querySelector('[data-k-pop-close]'); if (close) close.addEventListener('click', closePop);
      if (frame) frame.addEventListener('click', function (e) { if (pop && !pop.contains(e.target)) closePop(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePop(); });
      go(0);
    });
  }


  /* ---- Cabecera: menú móvil y buscador ----------------------------------- */
  function initHeader(scope) {
    scope.querySelectorAll('[data-k-header]').forEach(function (root) {
      if (root.dataset.kHeaderReady) return; root.dataset.kHeaderReady = '1';
      var drawer = root.querySelector('[data-k-drawer]'), openBtn = root.querySelector('[data-k-menu-open]');
      var search = root.querySelector('[data-k-search]');
      function openDrawer() { if (!drawer) return; drawer.hidden = false; document.documentElement.style.overflow = 'hidden'; if (openBtn) openBtn.setAttribute('aria-expanded', 'true'); var c = drawer.querySelector('[data-k-menu-close]'); if (c) c.focus(); }
      function closeDrawer() { if (!drawer) return; drawer.hidden = true; document.documentElement.style.overflow = ''; if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); } }
      if (openBtn) openBtn.addEventListener('click', openDrawer);
      root.querySelectorAll('[data-k-menu-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
      if (drawer) drawer.addEventListener('click', function (e) { if (e.target === drawer) closeDrawer(); });
      root.querySelectorAll('[data-k-search-open]').forEach(function (b) {
        b.addEventListener('click', function () { if (!search) return; search.hidden = !search.hidden; if (!search.hidden) { var i = search.querySelector('input[type="search"]'); if (i) i.focus(); } });
      });
      root.querySelectorAll('[data-k-search-close]').forEach(function (b) { b.addEventListener('click', function () { search.hidden = true; }); });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (drawer && !drawer.hidden) closeDrawer();
        if (search && !search.hidden) search.hidden = true;
      });
    });
  }


  /* ==== PÁGINAS INTERIORES ================================================= */

  /* Paneles (filtros): [data-k-open="id"] abre, [data-k-close] o clic fuera cierra */
  var kLastOpener = null;
  function closeOverlay(o) { if (!o) return; o.hidden = true; document.documentElement.style.overflow = ''; if (kLastOpener) kLastOpener.focus(); }
  if (!window.__kOverlays) {
    window.__kOverlays = true;
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-k-open]');
      if (t) { var o = document.getElementById(t.getAttribute('data-k-open')); if (o) { e.preventDefault(); kLastOpener = t; o.hidden = false; document.documentElement.style.overflow = 'hidden'; var f = o.querySelector('[data-k-close]'); if (f) f.focus(); } return; }
      var c = e.target.closest('[data-k-close]'); if (c) { closeOverlay(c.closest('.k-overlay')); return; }
      if (e.target.classList && e.target.classList.contains('k-overlay')) closeOverlay(e.target);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.k-overlay').forEach(function (o) { if (!o.hidden) closeOverlay(o); });
    });
  }

  /* Filtro por píldoras sin recargar (Best sellers, Proyectos): elementos con data-k-cat */
  function initPillFilter(scope) {
    scope.querySelectorAll('[data-k-pillfilter]').forEach(function (group) {
      if (group.dataset.kReady) return; group.dataset.kReady = '1';
      var target = document.getElementById(group.getAttribute('data-k-pillfilter')); if (!target) return;
      var note = document.getElementById(group.getAttribute('data-k-note') || '');
      group.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          group.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          var v = b.getAttribute('data-value'), n = 0;
          target.querySelectorAll('[data-k-cat]').forEach(function (it) { var ok = v === 'all' || it.getAttribute('data-k-cat') === v; it.hidden = !ok; if (ok) n++; });
          if (note) note.textContent = n + (n === 1 ? ' pieza' : ' piezas');
        });
      });
    });
  }

  /* Orden de la colección: envía el formulario al cambiar */
  function initSort(scope) {
    scope.querySelectorAll('[data-k-sort] select').forEach(function (sel) {
      if (sel.dataset.kReady) return; sel.dataset.kReady = '1';
      sel.addEventListener('change', function () { sel.form.submit(); });
    });
  }

  /* «Cargar más productos»: trae la página siguiente y añade las tarjetas */
  function initLoadMore(scope) {
    scope.querySelectorAll('[data-k-more]').forEach(function (btn) {
      if (btn.dataset.kReady) return; btn.dataset.kReady = '1';
      btn.addEventListener('click', function (e) {
        var grid = document.getElementById(btn.getAttribute('data-k-more')); if (!grid || !window.fetch) return;
        e.preventDefault(); btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '.5';
        fetch(btn.href).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.getElementById(grid.id);
          if (next) Array.prototype.forEach.call(next.querySelectorAll(':scope > .k-card'), function (c) { grid.appendChild(c); });
          var wrap = btn.closest('[data-k-more-wrap]'), nwrap = doc.querySelector('[data-k-more-wrap]');
          if (wrap && nwrap) { wrap.replaceWith(nwrap); initLoadMore(document); } else if (wrap) { wrap.remove(); }
                  }).catch(function () { window.location.href = btn.href; });
      });
    });
  }

  /* Recomendaciones de producto (Section Rendering API) */
  function initRecs(scope) {
    scope.querySelectorAll('[data-k-recs]').forEach(function (el) {
      if (el.dataset.kReady) return; el.dataset.kReady = '1';
      if (!window.fetch) return;
      var load = function () {
        fetch(el.getAttribute('data-k-recs')).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(el.id);
          if (fresh && fresh.querySelector('.k-card')) { fresh.removeAttribute('data-k-recs'); el.replaceWith(fresh); initRails(fresh); }
          else { el.remove(); }
        }).catch(function () {});
      };
      load();
    });
  }

  /* Ficha de producto: galería, opciones, cantidad, plazo de entrega y barra fija */
  function initProduct(scope) {
    scope.querySelectorAll('[data-k-product]').forEach(function (root) {
      if (root.dataset.kReady) return; root.dataset.kReady = '1';
      var money = function (cents) { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(cents / 100); };
      var moneyEl = root.querySelector('[data-k-money]'), moneyMap = {};
      try { moneyMap = JSON.parse(moneyEl ? moneyEl.textContent : '{}'); } catch (e) { moneyMap = {}; }

      function showMedia(id) {
        root.querySelectorAll('[data-k-slide]').forEach(function (s) {
          var on = s.getAttribute('data-k-slide') === String(id); s.hidden = !on;
          var v = s.querySelector('video'); if (v && !on) v.pause();
        });
        root.querySelectorAll('[data-k-thumb]').forEach(function (t) { t.setAttribute('aria-current', String(t.getAttribute('data-k-thumb') === String(id))); });
      }
      root.querySelectorAll('[data-k-thumb]').forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-k-thumb')); }); });

      var dataEl = root.querySelector('[data-k-variants]'), variants = [];
      try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }
      var idInput = root.querySelector('[data-k-variant-id]');
      var fieldsets = root.querySelectorAll('[data-k-opt-index]');

      function selected() {
        var opts = [];
        variants.length && variants[0].options.forEach(function (_, i) {
          var fs = root.querySelector('[data-k-opt-index="' + i + '"]');
          if (fs) { var c = fs.querySelector('input:checked'); opts[i] = c ? c.value : null; }
          else { opts[i] = variants[0].options[i]; }
        });
        return opts;
      }
      function update() {
        var opts = selected();
        var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
        fieldsets.forEach(function (fs) { var c = fs.querySelector('input:checked'), l = fs.querySelector('[data-k-opt-label]'); if (c && l) l.textContent = c.value; });
        var addBtns = root.querySelectorAll('[data-k-add]'), stock = root.querySelector('[data-k-stock]');
        if (!v) {
          addBtns.forEach(function (b) { b.disabled = true; var t = b.querySelector('[data-k-add-text]'); if (t) t.textContent = 'No disponible'; });
          if (stock) { stock.textContent = stock.getAttribute('data-out'); stock.classList.add('is-out'); }
          return;
        }
        if (idInput) idInput.value = v.id;
        var fm = moneyMap[v.id] || [];
        root.querySelectorAll('[data-k-price]').forEach(function (p) { p.textContent = fm[0] || money(v.price); });
        var cmp = root.querySelector('[data-k-compare]');
        if (cmp) { cmp.hidden = !(v.compare_at_price > v.price); if (v.compare_at_price) cmp.textContent = fm[1] || money(v.compare_at_price); }
        addBtns.forEach(function (b) { b.disabled = !v.available; var t = b.querySelector('[data-k-add-text]'); if (t) t.textContent = v.available ? 'Añadir al carrito' : 'Agotado'; });
        if (stock) { stock.textContent = v.available ? stock.getAttribute('data-in') : stock.getAttribute('data-out'); stock.classList.toggle('is-out', !v.available); }
        var sv = root.querySelector('[data-k-sticky-variant]'); if (sv) sv.textContent = v.title + ' · ';
        if (v.featured_media && v.featured_media.id) showMedia(v.featured_media.id);
        if (history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
      }
      fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });

      root.querySelectorAll('[data-k-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var q = b.parentElement.querySelector('input'); q.value = Math.max(1, (parseInt(q.value, 10) || 1) + Number(b.getAttribute('data-k-qty')));
        });
      });

      var eta = root.querySelector('[data-k-eta]');
      if (eta) {
        var addDays = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; } return d; };
        var f = function (d) { return d.toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, ''); };
        var now = new Date();
        eta.textContent = 'entre el ' + f(addDays(now, Number(eta.getAttribute('data-min')) || 2)) + ' y el ' + f(addDays(now, Number(eta.getAttribute('data-max')) || 5));
      }

      var bar = root.querySelector('[data-k-sticky]'), buy = root.querySelector('.k-pdp__buy');
      if (bar && buy && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var show = !e.isIntersecting && e.boundingClientRect.top < 0;
            bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', String(!show));
            bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
          });
        }).observe(buy);
      }
    });
  }

  /* DT - Añadir al carrito por AJAX con el carrito lateral de Dwell (header-actions en k-header).
     Pide a /cart/add.js las secciones de cada <cart-items-component> y lanza el evento cart:update de Dwell:
     el carrito lateral se refresca y se abre (ajuste «auto_open_cart_drawer») y el contador se actualiza.
     Sin carrito lateral (tipo de carrito «página», página /cart) o si algo falla, el formulario se envía normal. */
  if (!window.__kCartAjax) {
    window.__kCartAjax = true;
    /* Cualquier formulario de una sección k-* que envíe a /cart/add (ficha, tarjetas, Nº 1 de Best sellers,
       Shop the look, miniaturas…): los formularios nuevos quedan cubiertos sin tocar este archivo */
    var isCartForm = function (form) {
      if (!(form instanceof HTMLFormElement) || !form.closest('.k-section')) return false;
      try { return /\/cart\/add(\.js)?$/.test(new URL(form.action, window.location.href).pathname); } catch (err) { return false; }
    };
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!isCartForm(form)) return;
      if (!document.querySelector('cart-drawer-component') || !window.fetch) return;
      e.preventDefault();
      var btn = e.submitter || form.querySelector('[type="submit"]');
      var errorEl = form.querySelector('[data-k-cart-error]');
      if (errorEl) errorEl.remove();
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      var fd = new FormData(form);
      var ids = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) { ids.push(el.dataset.sectionId); });
      if (ids.length) { fd.append('sections', ids.join(',')); fd.append('sections_url', window.location.pathname); }
      var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      var sections, added = false;
      fetch(addUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            /* Error de Shopify (sin stock suficiente, etc.): se muestra junto al botón */
            var p = document.createElement('p');
            p.className = 'k-cart-error'; p.setAttribute('role', 'alert'); p.setAttribute('data-k-cart-error', '');
            p.textContent = res.description || res.message || 'No se ha podido añadir al carrito.';
            form.appendChild(p);
            /* Shopify puede haber añadido las unidades disponibles: el carrito se refresca igualmente */
          } else {
            sections = res.sections;
          }
          added = true;
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: form.id || '', data: { source: 'kinalu', itemCount: cart.item_count, sections: sections } }
          }));
        })
        .catch(function () { if (added) { window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart'; } else { form.submit(); } })
        .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
    });
  }

  /* Botón «Solicitar catálogo» → marca la opción Catálogo del formulario profesional */
  if (!window.__kChoose) {
    window.__kChoose = true;
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-k-choose]'); if (!t) return;
      var r = document.querySelector('[data-k-choice="' + t.getAttribute('data-k-choose') + '"]'); if (r) r.checked = true;
    });
  }


  /* Altura real de la cabecera fija → --k-header-h (barra de filtros y galería se pegan debajo) */
  function initHeaderHeight() {
    var h = document.querySelector('[data-k-sticky-header]'); if (!h) return;
    var wrap = h.closest('.shopify-section') || h;
    var set = function () { document.documentElement.style.setProperty('--k-header-h', wrap.getBoundingClientRect().height + 'px'); };
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(wrap); else window.addEventListener('resize', set);
  }


  /* Footer: columnas plegadas en móvil y siempre abiertas en escritorio */
  function initFooter(scope) {
    var mq = window.matchMedia('(max-width: 720px)');
    scope.querySelectorAll('.k-footer__col').forEach(function (d) {
      if (d.dataset.kReady) return; d.dataset.kReady = '1';
      d.open = !mq.matches;
      d.querySelector('summary').addEventListener('click', function (e) { if (!mq.matches) e.preventDefault(); });
    });
    if (!window.__kFootMq && mq.addEventListener) { window.__kFootMq = true; mq.addEventListener('change', function () { document.querySelectorAll('.k-footer__col').forEach(function (d) { d.open = !mq.matches; }); }); }
  }


  /* Contacto: aviso de horario con la hora de Madrid y campo de pedido según el motivo */
  function initContact(scope) {
    scope.querySelectorAll('[data-k-hours]').forEach(function (el) {
      if (el.dataset.kReady) return; el.dataset.kReady = '1';
      var parts = {};
      try {
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false })
          .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      } catch (e) { return; }
      var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday);
      var mins = (parseInt(parts.hour, 10) % 24) * 60 + parseInt(parts.minute, 10);
      var range = (el.getAttribute('data-days') || '1-5').split('-').map(Number);
      var open = day >= range[0] && day <= range[1] && mins >= Number(el.getAttribute('data-open')) * 60 && mins < Number(el.getAttribute('data-close')) * 60;
      el.classList.toggle('is-open', open);
      var t = el.getAttribute(open ? 'data-open-text' : 'data-closed-text'), span = el.querySelector('span');
      if (t && span) span.textContent = t;
    });
    scope.querySelectorAll('[data-k-reasons]').forEach(function (group) {
      if (group.dataset.kReady) return; group.dataset.kReady = '1';
      var form = group.closest('form'), field = form && form.querySelector('[data-k-order-field]'); if (!field) return;
      var sync = function () { var c = group.querySelector('input:checked'); field.hidden = !(c && c.hasAttribute('data-k-needs-order')); };
      group.addEventListener('change', sync); sync();
    });
  }

  function init(scope) { initHeader(scope); initRails(scope); initVideos(scope); initLooks(scope); initPillFilter(scope); initSort(scope); initLoadMore(scope); initRecs(scope); initProduct(scope); initFooter(scope); initContact(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); initHeaderHeight(); });
  else { init(document); initHeaderHeight(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initHeaderHeight(); });
})();
